<style lang="sass" scoped>

</style>
<template lang="pug">
div
  router-view
</template>

<script>
export default {
  name: 'layout',
  components: {
    
  },
  data() {
    return {
      
    }
  },
  methods: {
    
  },
}
</script>
